module.exports = __webpack_public_path__ + "static/img/1.1dfc8f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/1.png
// module id = XlRN
// module chunks = 0